export default "__VITE_ASSET__gAyjrFmz__"